module.exports = __webpack_public_path__ + "img/hamburger.c275e518.svg";